import behanceLogo from "../images/social-media-logos/behance-logo.png";
import instagramLogo from "../images/social-media-logos/instagram-logo.svg";

const socialLogos = [
  {
    src: behanceLogo,
    alt: "Behance Logo",
    href: "https://www.behance.net/dedgrl",
    name: "Behance",
  },
  {
    src: instagramLogo,
    alt: "Instagram Logo",
    href: "https://www.instagram.com/dedgrl.log/",
    name: "Instagram",
  },
];

export default socialLogos;
